import styled from '@emotion/styled';

export const TableNavButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: 1.5px solid transparent;
  font-size:20px;
  font-weight: 400;
  line-height: 100%;
  color: ${(props) => props.theme.colors.primaryTextColor};
  letter-spacing: 1px;
  border-color: ${(props) => props.theme.colors.gray};
  //border-color: transparent;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor};
  }
  &.active {
    background-color: ${(props) => props.theme.colors.primaryColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
    color: ${(props) => props.theme.colors.secondaryTextColor};
  }
`;
